<div
  class="container"
  (mouseover)="mouseOver$.next(true)"
  (mouseout)="mouseOver$.next(false)">
  @for (toast of toasts$ | async; track toast) {
    <ppl-toast
      [toast]="toast"
      [containerMouseOver$]="mouseOver$"
      [@slideInOut]
      (close)="onCloseSingle(toast)"></ppl-toast>
  }
</div>
